<div mat-dialog-title>
  <div class="h4 mb-0" i18n="@@dpr.downloadDprDialog.lblDownloadDpr">Download DPR</div>
  <button mat-icon-button (click)="onCancel()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content class="bg-light">
  <ng-container [formGroup]="downloadFormControl">
    <app-date-range-picker
      [startDate]="data.startDate | cloneDeep"
      [endDate]="data.endDate | cloneDeep"
      [minDate]="data.startDate"
      [maxDate]="data.endDate"
      [useExplicitActions]="false"
    ></app-date-range-picker>

    <mat-card class="mt-3 p-3">
      <h3 class="mb-0" i18n="@@dpr.downloadDprDialog.lblFileTypes">File types</h3>
      <hr />
      <div class="checkbox-wrapper">
        <mat-checkbox color="primary" formControlName="includeReports">
          <span i18n="@@dpr.downloadDprDialog.btnGeneratedReports">Generated reports</span>
        </mat-checkbox>

        <mat-checkbox color="primary" formControlName="includeSignedReports">
          <span i18n="@@dpr.downloadDprDialog.btnSignedReports">Signed reports</span>
        </mat-checkbox>

        <mat-checkbox color="primary" formControlName="includeAttachments">
          <span i18n="@@dpr.downloadDprDialog.btnAttachments">Attachments</span>
        </mat-checkbox>

        <mat-checkbox color="primary" formControlName="includeAppendices">
          <span i18n="@@dpr.downloadDprDialog.btnAppendices">Appendices</span>
        </mat-checkbox>
      </div>
    </mat-card>
  </ng-container>
</div>

<div mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="onDownload()" [disabled]="isDownloadButtonDisabled" cdkFocusInitial>
    <mat-icon svgIcon="cloud-download"></mat-icon>
    {{StaticMessage.DownloadButton | staticMessage}}
  </button>
  <button mat-button color="primary" (click)="onCancel()">{{StaticMessage.CloseButton | staticMessage}}</button>
</div>
